import { useContext, useState } from "react";
import axios from "axios";
import { StoresContext } from "../stores";
import { toast } from "react-hot-toast";
import TriggerAPI from "../apis/TriggerAPI";
import { ITriggerRequest } from "../interfaces/ITrigger";

export const useTrigger = () => {
    
    const { triggerStore, authorizationStore } = useContext(StoresContext);
    const [loading, setLoading] = useState(false);

    const trigger = async (acionamento: ITriggerRequest) => {
        setLoading(true);
            try {
            const { data, status } = await TriggerAPI.trigger(acionamento);
            if(status === 200) {
                toast.success('Acionamento acatado com sucesso!');
                if(authorizationStore.visitor?.acionamentos.includes("Quantidade"))
                {
                    if(authorizationStore.visitor)
                    {
                        if(authorizationStore.visitor.quantidade)
                        {
                            authorizationStore.visitor.quantidade = authorizationStore.visitor.quantidade - 1;
                            if(authorizationStore.visitor.quantidade === 0) {
                                triggerStore.expired = true;
                                setLoading(false);
                                toast.error("Quantidade expirada");
                                return 'sucesso'
                            }
                        }
                    }
                    else alert("Erro interno: Sem visitante selecionado");
                }
                else
                {
                    if(authorizationStore.visitor)
                    {
                        if(authorizationStore.visitor.quantidade)
                        {
                            authorizationStore.visitor.quantidade = authorizationStore.visitor?.quantidade - 1;
                        }
                        if(data.mensagem === '0') {
                            triggerStore.expired = true;
                            setLoading(false);
                            return 'sucesso'
                        }
                    }
                }
                setLoading(false);
                return 'sucesso'
            }
            else if(status === 204) {
                toast.error('Erro ao fazer o acionamento, por favor tente novamente');
                setLoading(false);
            }
            setLoading(false);
        } catch(e) {
            if(axios.isAxiosError(e))
            {
                toast.error(e.response?.data.mensagem);
            }
            setLoading(false);
        }
    }

    return {
        trigger,
        loading
    }

}